<template>
  <alzata-odata-table
    ref="grid"
    clickable
    title="Dogs"
    endpoint="/api/v1/dogs"
    :columns="[
      {
        id: 'Name',
        label: 'Name',
        sortable: true,
      },
      {
        id: 'Gender',
        label: 'Gender',
        sortable: true,
      },
      {
        id: 'Breed',
        label: 'Breed',
        sortable: true,
      },
      {
        id: 'DateOfBirth',
        label: 'DOB',
        sortable: true,
        formatter: (x) => {
          const date = new Date(x.dateOfBirth);
          const dogDob = date.toLocaleDateString();
          const dogAge = age(date);
          return `${dogDob} (${dogAge} years)`;
        },
      },
    ]"
    :actions="[
      {
        id: 'edit',
        icon: (item) => 'far/pencil',
        tooltip: 'Edit',
        default: true,
        click: show,
      },
      {
        id: 'delete',
        icon: (item) => 'far/trash',
        tooltip: 'Delete',
        default: true,
        click: showDelete,
      },
    ]"
  >
    <template v-slot:buttons>
      <button
        type="button"
        class="btn btn-primary btn-sm ms-1"
        @click="showCreate({})"
      >
        <alzata-icon icon="far/plus-circle" /> Add Dog
      </button>
    </template>
  </alzata-odata-table>
  <edit-dog-dialog ref="editDialog" @save="save" />
  <create-dog-dialog ref="createDialog" @save="save" />
  <delete-dog-dialog ref="deleteDialog" @deleteDog="deleteDog" />
</template>

<script>
import EditDogDialog from "@/dialogs/EditDogDialog.vue";
import CreateDogDialog from "@/dialogs/CreateDogDialog.vue";
import DeleteDogDialog from "@/dialogs/DeleteDogDialog.vue";
export default {
  name: "DogList",
  components: {
    EditDogDialog,
    CreateDogDialog,
    DeleteDogDialog
  },
  computed: {
    console: () => console,
    window: () => window,
  },
  data() {
    return {
      showEditDialog: false
    };
  },
  methods: {
    age(dob) {
      var today = new Date();
      var birthDate = new Date(dob);
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    show(dog) {
      this.$refs.editDialog.show(dog);
    },
    showCreate(dog) {
      this.$refs.createDialog.show(dog);
    },
    showDelete(dog) {
      this.$refs.deleteDialog.show(dog);
    },
    async save(dog) {
      const body = {
        name: dog.name,
        feedingInstructions: dog.feedingInstructions,
        primaryVeterinarianId: dog.primaryVeterinarianId,
        emergencyVeterinarianId: dog.emergencyVeterinarianId,
        gender: dog.gender,
        breed: dog.breed,
        dateOfBirth: dog.dateOfBirth,
        adoptionDate: dog.adoptionDate,
      };
      if (dog.id) {
        await this.apiClient.putJson(`/api/v1/dogs/${dog.id}`, { body });
      } else {
        const res = await this.apiClient.postJson("/api/v1/dogs", { body });
        if (!res.success) {
          alert("error saving dog");
          return;
        }
        dog.id = res.id;
      }

      this.$refs.grid.reload();
      this.$refs.editDialog.hideEditDog();
      this.$refs.createDialog.hideCreateDog();
    },
    async deleteDog(dog) {
      await this.apiClient.doDelete(`/api/v1/dogs/${dog.id}`, { });

      this.$refs.grid.reload();
      this.$refs.deleteDialog.hide();
    },
  },
};
</script>
